import React, { useState } from 'react';
import Media from 'react-media';
import PropTypes from 'prop-types';
import YouTube from "react-youtube";

import {
	makeStyles,
	useTheme
} from '@material-ui/core';

import Thumbnail from './Thumbnail.js';

const maxHeight = 400;
const minHeight = 200;
const styles = makeStyles(theme => ({
	embedResponsive: {
		position: "relative",
		display: "block",
		height: "100%",
		padding: "0",
		overflow: "hidden"
	},

	ratio16by9: {
		//paddingBottom: "28.6%"
	},

	video: {
		position: "absolute",
		top: "0",
		bottom: "0",
		left: "0",
		width: "100%",
		height: "100%",
		border: "0",
		maxHeight: minHeight,

		[theme.breakpoints.up('sm')]: {
			maxHeight: maxHeight
		}
	}
}));

function YoutubePostVideo(props) {
	const theme = useTheme();
	const [brokenVideo, setBrokenVideo] = useState(false);

	const handleError = (event) => {
		setBrokenVideo(true);
	};

	let classes = styles(),
		{video, onPlay, onStop, onReady, uuid} = props,
		videoId = video.substring(video.lastIndexOf("/")+1);

	return (
		<div style={{height: "100%"}}>
			{!brokenVideo ? (
				<div className={`${classes.embedResponsive} ${classes.ratio16by9}`}>
					<YouTube
						videoId={videoId}
						onError={handleError}
						onPlay={() => onPlay(uuid)}
						onPause={() => onStop(uuid)}
						onEnd={() => onStop(uuid)}
						onReady={(event) => onReady(uuid, event)}
						className={`${classes.video}`}>
					</YouTube>
				</div>
			) : (
				<Media query={{minWidth: theme.breakpoints.values.sm}}>
					{matches => (
						<Thumbnail image="" center fitToHeight={matches ? maxHeight : minHeight} />
					)}
				</Media>
			)}
		</div>
	);
}

YoutubePostVideo.propTypes = {
	useIframeVideo: PropTypes.bool,
	video: PropTypes.string,
	onPlay: PropTypes.func,
	onStop: PropTypes.func,
	onReady: PropTypes.func,
	uuid: PropTypes.number
};

export default YoutubePostVideo;